const PEOPLE = [
  'Adam_Biciste',
  'Andrea_Sliacka',
  'Zaneta_Mikusova',
  'Lukas_Rykr',
  'Tomas_Rokos',
  'Lenka_Hanakova',
  'Simona_Kijonkova',
  'Jaromir_Kijonka',
  'Tomas_Pesek',
];

const GROUPED_PEOPLE: { i: number; people: string[] }[] = [];
for (let i = 0; i < PEOPLE.length; i += 3) {
  GROUPED_PEOPLE.push({
    i,
    people: PEOPLE.slice(i, i + 3),
  });
}

export { GROUPED_PEOPLE };
